import { render, staticRenderFns } from "./EstornoComponent.vue?vue&type=template&id=5edc94b8"
import script from "./EstornoComponent.vue?vue&type=script&lang=js"
export * from "./EstornoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports